import {IconButton} from '@jetbrains/teamcity-ui/dist/components'
import classnames from 'classnames'

import {usePermission} from '../../../hooks/usePermission'
import type {ProjectId} from '../../../types'
import {Permission, ROOT_PROJECT_ID} from '../../../types'
import {noop} from '../../../utils/empty'

import styles from './StarBuild.module.css'

type Props = {
  projectId?: ProjectId | null
  className?: string
  isStarred: boolean
  showEmpty?: boolean
  hideEmptyDisabled?: boolean
  size?: 'S' | 'M'
  onStar?: (starred: boolean) => unknown
}

function StarBuild({
  projectId,
  className,
  isStarred,
  showEmpty = false,
  hideEmptyDisabled,
  size = 'S',
  onStar = noop,
}: Props) {
  const canTag = usePermission(Permission.TAG_BUILD, projectId)
  const canChangeOwmProfile = usePermission(Permission.CHANGE_OWN_PROFILE, ROOT_PROJECT_ID)
  const isStarrable = canTag && canChangeOwmProfile

  const getTitle: () => string = () => (isStarred ? 'Remove from favorites' : 'Add to favorites')

  const handleStar: () => unknown = () => onStar(!isStarred)

  const invisibleClasses = classnames({
    [styles.invisible]: !showEmpty && !isStarred,
    [styles.hidden]: !isStarrable && !isStarred,
  })
  const classes = classnames(styles.button, className, invisibleClasses, {
    [styles.starred]: isStarred,
  })

  if (hideEmptyDisabled && !isStarrable && !isStarred) {
    return null
  }

  return (
    <IconButton
      title={getTitle()}
      disabled={!isStarrable}
      icon={
        isStarred
          ? `star-filled${size === 'M' ? '-20px' : ''}`
          : `star-empty${size === 'M' ? '-20px' : ''}`
      }
      onClick={handleStar}
      className={classes}
      iconClassName={invisibleClasses}
    />
  )
}

export default StarBuild
